export default "__VITE_ASSET__DFOMGGq8__"